import { createSelector } from 'reselect'
import adminOnboardingGetDurationDaysSelector from 'redux/selectors/admin_onboarding/admin_onboarding_get_duration_days'
import adminOnboardingGetIsTrialFromSFSelector from 'redux/selectors/admin_onboarding/admin_onboarding_is_trial_from_sf_selector'

export default createSelector(
	[ adminOnboardingGetDurationDaysSelector, adminOnboardingGetIsTrialFromSFSelector ],
	(durationDays, isTrialFromSFData) => ({
		durationDays,
		isTrialFromSF: isTrialFromSFData.isTrialFromSF,
	})
)
